export const DASHBOARD_PATH = '/dboard';

export const URL_PARAM_START_ROUND = 'start-round';

export const SHARE_URL_BASE = 'https://stude.co/a/';

export const OWNER_ROLE = 'guild_owner';
